(ns pfo.test
  (:require [cljs.test :refer-macros [run-all-tests]]
            [pfo.task.model]))

(defn run-tests []
  (run-all-tests #"pfo.*"))

